export default __webpack_public_path__ + "static/media/grafema_amcc_11.16b70ce5.jpg";